import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var CURRENCIES_WITHOUT_CENTS = ['CNY', 'TWD', 'RUB'];

/**
 * Create props injected in components.
 */
export default function createTranslatorProps(translator) {
  var translate = translator.translate,
    localize = translator.localize,
    createNumberFormat = translator.createNumberFormat,
    mapCurrencyISOToSymbol = translator.mapCurrencyISOToSymbol,
    _formatUserAmount = translator.formatUserAmount;
  return {
    __: translate,
    /**
     * Format dates.
     */
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LLL Z';
      var toUtc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return localize(date, toUtc).format(format);
    },
    /**
     * Format numbers.
     */
    formatNumber: function formatNumber(number) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return createNumberFormat(_objectSpread({
        style: 'decimal'
      }, options)).format(number);
    },
    /**
     * Format user provided amounts(string) to API-friendly format (number).
     */
    formatUserAmount: function formatUserAmount(amount) {
      return _formatUserAmount(amount);
    },
    /**
     * Format prices.
     */
    formatPrice: function formatPrice(price, currency) {
      var options = {};
      var noCents = CURRENCIES_WITHOUT_CENTS.includes(currency);
      // $FlowIgnore[sketchy-null-string]
      if (currency) {
        options.style = 'currency';
        options.currency = currency;
        options.maximumFractionDigits = noCents ? 0 : undefined;
        options.minimumFractionDigits = noCents ? 0 : undefined;
        return createNumberFormat(options).format(price);
      }
      if (global.__DEV__) {
        // we log with console.log as this is a nice to have information,
        // but does not worth the assle of setting up logger.
        // eslint-disable-next-line no-console
        console.warn('<Price /> has no currency set');
      }
      return createNumberFormat(_objectSpread({
        style: 'decimal'
      }, options)).format(price);
    },
    /**
     * Return the currency symbol according to current locale from it's ISO code.
     * Use the localeData provided by Intl polyfill to map.
     */
    formatCurrency: mapCurrencyISOToSymbol,
    /**
     * Low level utility to create a localized instance of moment.
     * Do not use outside this module.
     * Return a moment instance.
     */
    localize: localize
  };
}